<template>
  <div></div>
</template>
    
<script>
export default {
  name: "AddRefundView",
  components: {},
};
</script>